<template>
  <div>
    <template v-if="message === null">
      Bitte selektiere eine Nachricht ...
    </template>

    <template v-else>
      <div v-if="$vuetify.breakpoint.xs" style="display: inline-flex;">
        <v-icon :color="$finColors.primaryDark" class="mr-2" large @click="$emit('input')">
          icon-arrow-left
        </v-icon>
        <p class="mb-0" style="height: 35px; line-height: 35px;">
          {{ message.createdAt | dayAndMonthAndYearNumericAndHour }}</p>
      </div>
      <h2 class="mb-4" v-html=" message.title"/>
      <div v-html="message.text"/>
    </template>
  </div>
</template>

<script>
export default {
  name: 'fin-speaker-message',
  props: {
    message: {
      type: Object,
      default: null
    }
  }
}
</script>

<style scoped>

</style>
